document.addEventListener('DOMContentLoaded', () => {

    if(document.querySelector("div.job-search a") !== null) {
        const searchItem = document.querySelector("div.job-search a");
        const itemClone = (() => {
            return searchItem.cloneNode(true);
        })
        document.querySelector('.layout-page-header-inner').insertBefore(itemClone(), document.querySelector('.mobile-burger'));
        let jobSearchListItem = document.createElement('li')
        jobSearchListItem.classList.add('job-search')
        jobSearchListItem.appendChild(itemClone());
        document.querySelector('.drilldown.menu').insertBefore(jobSearchListItem, document.querySelector('.drilldown.menu li:first-child'))
    }
    document.querySelectorAll('.submenu ul').forEach((item) => {
        let anchorSelection = item.firstChild.nextSibling.firstChild;
        if(anchorSelection.classList.contains('Navigation-itemLevel3')) {
            anchorSelection.parentNode.previousSibling.firstChild.classList.remove('Navigation-itemLevel2')
            anchorSelection.parentNode.previousSibling.firstChild.classList.add('Navigation-itemLevel3')
        }
    })

    //Toggling header menu
    function afTogglingHeaderMenu(menuItem, isMouseleave = false,eventListener = "mouseover") {
        if (((eventListener === "mouseover" || eventListener === "mouseleaver") && window.innerWidth > 1200) || (eventListener === "click" && window.innerWidth < 1201) || eventListener === "irelevant") {
            let menuItemParent = menuItem.parentElement;
            let menuItemParentParent = menuItemParent.parentElement;
            let openedMenu = menuItemParentParent.querySelectorAll( ":scope > .is-open")[0];

            if (openedMenu && openedMenu.parentElement.className === "drilldown menu" && openedMenu !== menuItemParent) {
                openedMenu.className = "";
                openedMenu.querySelectorAll(":scope > .open")[0].className = "submenu";
                const arrowOpened = openedMenu.querySelectorAll(":scope > .mobile-arrow-down.open")[0];
                if(arrowOpened) {
                    arrowOpened.className = "mobile-arrow-down";
                }
            }
            if(!isMouseleave && menuItemParent.className.indexOf("is-open") === -1 && menuItem.className.indexOf("Navigation-itemLevel1") > -1 && window.innerWidth > 1200 || !isMouseleave && menuItem.className.indexOf("Navigation-itemLevel2") > -1 || menuItem.className.indexOf("Navigation-itemLevel1") > -1 && window.innerWidth < 1201) {
                const subMenu = menuItemParent.querySelectorAll(":scope > .submenu")[0];
                if (subMenu) {
                    menuItemParent.classList.toggle("is-open");
                    subMenu.classList.toggle("open");
                    menuItemParent.querySelectorAll(":scope > .mobile-arrow-down")[0].classList.toggle("open");
                    const span = menuItem.querySelectorAll(":scope > span")[0];
                    if (span) {
                        span.classList.toggle("sub-menu-3-level-closed");
                    }
                }
            }
        }

    }

    //Opening page on a button click for desktop
    function afOpenPageOnButtonClickForDesktop(button) {
        if(window.innerWidth > 1200) {
            const rootURL = location.protocol + '//' + location.host;
            window.open(rootURL + button.getAttribute("href"),"_self")
        }
    }

    const menuItems = document.querySelectorAll("body:not(.neos-backend) .app-site-navigation ul.drilldown li button");
    const menuItemsLength = menuItems.length;
    for (let i = 0; i < menuItemsLength; i++) {
        (function() {
            if (menuItems[i].className.indexOf("Navigation-itemLevel1") > -1) {
                menuItems[i].addEventListener("click",function() {afTogglingHeaderMenu(menuItems[i],false,"click")});
                menuItems[i].addEventListener("click",function() {afOpenPageOnButtonClickForDesktop(menuItems[i])});
                menuItems[i].addEventListener("mouseover",function() {afTogglingHeaderMenu(menuItems[i],false,"mouseover")});
                menuItems[i].parentElement.addEventListener("mouseleave",function() {afTogglingHeaderMenu(menuItems[i],true,"mouseleave")});
            }
            else {
                menuItems[i].addEventListener("click",function() {afTogglingHeaderMenu(menuItems[i],false,"irelevant")});
            }
        })();
    }

    //When user leaver header menu completely
    function afClosingHeaderMenuOnMouseLeave() {
        if (window.innerWidth > 1200) {
            const openedMenus = document.querySelectorAll( "li.is-open");
            const openedMenuLength = openedMenus.length;
            for (let i = 0; i < openedMenuLength;i++) {
                const openedMenu = openedMenus[i];
                if (openedMenu && openedMenu.parentElement.className === "drilldown menu") {
                    openedMenu.className = "";
                    openedMenu.querySelectorAll(":scope > .open")[0].className = "submenu";
                    const arrowOpened = openedMenu.querySelectorAll(":scope > .mobile-arrow-down.open")[0];
                    if(arrowOpened) {
                        arrowOpened.className = "mobile-arrow-down";
                    }
                }
            }
        }
    }

    document.querySelectorAll(".app-site-navigation")[0].addEventListener("mouseleave",afClosingHeaderMenuOnMouseLeave);
});
